var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeachBall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 179,
    viewBox: "0 0 179 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.953 53.2544L136.933 52.99L50.9978 140.312C79.1622 161.473 119.151 155.795 140.312 127.631C157.183 105.176 156.995 75.2072 141.953 53.2544Z",
    fill: "#00BAB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.948 33.4662L109.297 28.7184C84.0243 20.3816 55.1874 28.5431 38.3163 50.9979C17.1554 79.1622 22.8333 119.151 50.9976 140.312L110.948 33.4662Z",
    fill: "#FD6144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.209 49.5249L93.7973 92.6828L50.9975 140.312C36.9153 129.732 42.6542 98.3205 63.8151 70.1561C77.8466 51.4808 95.1338 38.9235 109.297 35.6629C110.498 40.4829 113.973 45.5906 119.209 49.5249Z",
    fill: "#FF8468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.953 53.2544C140.103 54.4525 137.811 55.0941 135.283 55.1867C130.319 55.3748 124.446 53.4593 119.21 49.5249C113.973 45.5906 110.499 40.4829 109.297 35.6631C108.683 33.2091 108.661 30.8291 109.297 28.7185C115.724 30.8397 121.921 34.0267 127.631 38.3166C133.341 42.6064 138.127 47.672 141.953 53.2544Z",
    fill: "#FCE190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.283 55.1867C136.093 69.698 128.845 89.7973 114.813 108.473C93.6522 136.637 65.0798 150.893 50.9976 140.312L119.209 49.5249C124.446 53.4593 130.319 55.3748 135.283 55.1867Z",
    fill: "#80E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3628 43.0356C72.2914 43.7332 73.6098 43.546 74.3074 42.6175C75.0051 41.6889 74.8179 40.3706 73.8893 39.6729C72.9608 38.9752 71.6424 39.1624 70.9448 40.091C70.2471 41.0195 70.4343 42.3379 71.3628 43.0356Z",
    fill: "#FF8468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.636 106.463C102.565 107.161 103.883 106.973 104.581 106.045C105.279 105.116 105.091 103.798 104.163 103.1C103.234 102.403 101.916 102.59 101.218 103.518C100.521 104.447 100.708 105.765 101.636 106.463Z",
    fill: "#00BAB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9634 94.6852C100.892 95.3828 102.21 95.1956 102.908 94.2671C103.606 93.3385 103.419 92.0202 102.49 91.3225C101.561 90.6248 100.243 90.812 99.5453 91.7406C98.8477 92.6691 99.0349 93.9875 99.9634 94.6852Z",
    fill: "#00BAB9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127.576,
    height: 127.576,
    fill: "white",
    transform: "translate(76.6328) rotate(36.9189)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeachBall);
export default __webpack_public_path__ + "static/media/beach-ball.b7e393cf73cc9a079a2ccd65fa136ece.svg";
export { ForwardRef as ReactComponent };